/* eslint-disable */
import sysConfig from '@/configs/sys';

const matlsApiUrl = sysConfig.matlsApiUrl;

export default {
  getKeysByType(type) {
    return fetch
      .get(`${matlsApiUrl}/keys/getkeysbytype/${type}`)
      .then(res => res.json());
  }
};